import * as React from "react";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

export default function TitlePageMenu({ list }) {
  const navigate = useNavigate();
  const listDefault = [
    {
      label: "",
      href: "#",
      icon: <HomeIcon fontSize="small" />,
    },
  ];
  const listMap = list.length > 0 ? list : listDefault;

  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        {listMap.map((opt, index) => (
          <StyledBreadcrumb
            key={index}
            onClick={() => {
              navigate(opt.href);
            }}
            label={opt.label}
            icon={opt.icon}
          />
        ))}
      </Breadcrumbs>
    </div>
  );
}
